<ng-container *ngIf="isFloating">
    <div class="assist-left-floating-bar">
        <ng-container *ngFor="let b of benefits; let i = index">
            <div class="benefit-glass-tag staggered-pill" *ngIf="i < visibleBenefitsCount">
                <img [src]="b.icon" [alt]="b.alt" />
                <span>{{ b.text }}</span>
            </div>
        </ng-container>
    </div>
</ng-container>

<ng-container *ngIf="!isFloating">
    <div class="assist-trust-container">
        <div class="trust-header-pill">
            <span>TRAVEL SMART. PAY IN EASY EMIS.</span>
        </div>

        <div class="trust-cards-list">
            <div class="benefit-feature-card">
                <div class="icon-box">
                    <img src="assets/images/assist-icon-02.png" alt="Zero Hidden Charges" />
                </div>
                <div class="item-content">
                    <h5>Zero Hidden Charges</h5>
                    <p>Transparent pricing with zero hidden fees or unexpected surprises.</p>
                </div>
            </div>

            <div class="benefit-feature-card">
                <div class="icon-box">
                    <img src="assets/images/assist-icon-04.png" alt="Lightning Fast Support" />
                </div>
                <div class="item-content">
                    <h5>Lightning Fast Support</h5>
                    <p>Dedicated travel finance experts available to assist you anytime.</p>
                </div>
            </div>

            <div class="benefit-feature-card">
                <div class="icon-box">
                    <img src="assets/images/assist-icon-03.png" alt="Seamless AutoPay" />
                </div>
                <div class="item-content">
                    <h5>Seamless AutoPay</h5>
                    <p>Quick one-time setup for smooth, automated monthly repayments.</p>
                </div>
            </div>

            <div class="benefit-feature-card">
                <div class="icon-box">
                    <img src="assets/images/assist-icon-01.png" alt="Budget-Friendly Credit" />
                </div>
                <div class="item-content">
                    <h5>Budget-Friendly Credit</h5>
                    <p>Tailored credit line designed exclusively for flights, hotels, and tours.</p>
                </div>
            </div>
        </div>
    </div>
</ng-container>